import { Reducer } from 'redux';
import { IUserState } from './types';
import { AgencyActionTypes } from '../agency/types';
import { RegionConfigDashboardTypes } from '../region_config_dashboard/types';
import { API_CALLS } from '../../utilities/constants';

export const initialState: IUserState = {
  apiCallsInProgress: [],
};

const reducer: Reducer<IUserState> = (state = initialState, action) => {
  switch (action.type) {
    case RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS: {
      const isInProgressAlready =
        state.apiCallsInProgress.find(x => x.callName === API_CALLS.GET_ALL_REGION_CONFIGS) !== undefined;
      const apiCallsInProgress = !isInProgressAlready
        ? [
            ...state.apiCallsInProgress,
            {
              callName: API_CALLS.GET_ALL_REGION_CONFIGS,
              retryNumber: 0,
              timeToNextCall: 0,
              hasFailed: false,
            },
          ]
        : state.apiCallsInProgress;

      return {
        ...state,
        apiCallsInProgress,
      };
    }

    case RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS_SUCCESS:
    case RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS_FAILURE: {
      return {
        ...state,
        apiCallsInProgress: state.apiCallsInProgress.filter(x => x.callName !== API_CALLS.GET_ALL_REGION_CONFIGS),
      };
    }

    case AgencyActionTypes.GET_AGENCIES: {
      const isInProgressAlready =
        state.apiCallsInProgress.find(x => x.callName === API_CALLS.GET_AGENCIES) !== undefined;
      const apiCallsInProgress = !isInProgressAlready
        ? [
            ...state.apiCallsInProgress,
            {
              callName: API_CALLS.GET_AGENCIES,
              retryNumber: 0,
              timeToNextCall: 0,
              hasFailed: false,
            },
          ]
        : state.apiCallsInProgress;

      return {
        ...state,
        apiCallsInProgress,
      };
    }

    case AgencyActionTypes.GET_AGENCIES_SUCCESS:
    case AgencyActionTypes.GET_AGENCIES_FAILURE: {
      return {
        ...state,
        apiCallsInProgress: state.apiCallsInProgress.filter(x => x.callName !== API_CALLS.GET_AGENCIES),
      };
    }

    default:
      return state;
  }
};

export { reducer as userReducer };
